import styled from "styled-components";
import {HeaderNavbarContainerDefaultBox} from "./header-navbar-container.default.box";

export const HeaderNavbarContainerMrGreenBox = styled(HeaderNavbarContainerDefaultBox)`
  box-shadow: 0px 11px 25px rgba(0, 0, 0, 0.4);
  background-color: ${props => props.theme.colors.brandPrimaryDark};
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    border-bottom: none;
  }
`;
